export var Operators = /*#__PURE__*/function (Operators) {
  Operators["GREATER_OR_EQUALS"] = ">=";
  Operators["LESS_OR_EQUALS"] = "<=";
  return Operators;
}({});

/* Routes */

export var Routes = /*#__PURE__*/function (Routes) {
  Routes["DASHBOARD"] = "/";
  Routes["DEALROOM"] = "/dealroom";
  return Routes;
}({});

// string value set in the DB when market, neighborhood or region are not available
export var OUT_OF_MARKET = "Other";

// used for platform placements of dialogs/drawers/modals on top of each other.
// current usage : TourStops, TourStop, ListingComments
export var Z_INDEX_BASELINES = /*#__PURE__*/function (Z_INDEX_BASELINES) {
  Z_INDEX_BASELINES[Z_INDEX_BASELINES["MUI_DRAWER"] = 1300] = "MUI_DRAWER";
  Z_INDEX_BASELINES[Z_INDEX_BASELINES["MUI_DIALOG"] = 1400] = "MUI_DIALOG";
  Z_INDEX_BASELINES[Z_INDEX_BASELINES["MUI_MODAL"] = 1500] = "MUI_MODAL";
  return Z_INDEX_BASELINES;
}({});

// Select menus, date pickers, and other dropdown overlays render above drawers (1300).
export var OVERLAY_MENU_Z_INDEX = 1400;

// max file size for file uploads
export var MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB

// max number of files that can be uploaded at once
export var MAX_FILES_PER_UPLOAD = 5;

// Restricted Organization ID (JLL Demo)
// This is an internal demo/testing organization that is restricted from certain operations
export var RESTRICTED_ORGANIZATION_ID = "a958d71c-9de5-4077-88c8-48017bffb793";
export var MAX_INT_VALUE = 2147483647; // GraphQL Int max (32-bit signed)